import { CustomerRow } from './CustomersV2.types';

/**
 * Shared by the company-name trigger and the `?buyer=` URL param, which are the
 * only two ways the profile modal opens — both must agree or a shared link can
 * open a profile the table refuses to.
 */
export const canOpenProfile = (row: CustomerRow): boolean => {
  if (row.application_stage.value === 'declined') return false;
  // Cross-sell rows reach `complete` without ever being given a limit.
  if (row.application_stage.value === 'complete' && row.limit_amount === null) {
    return false;
  }
  return true;
};
